import { render, staticRenderFns } from "./LicenseDialog.vue?vue&type=template&id=9bff98c4&scoped=true&"
import script from "./LicenseDialog.vue?vue&type=script&lang=js&"
export * from "./LicenseDialog.vue?vue&type=script&lang=js&"
import style0 from "./LicenseDialog.vue?vue&type=style&index=0&id=9bff98c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bff98c4",
  null
  
)

export default component.exports